import React from "react";
import api from "../servicios/api";
import { authHeaders } from "../servicios/auth";

class Listarsolvencias extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            datosCargados: false,
            solvencias: [],
            busqueda: ""
        };
    }

    componentDidMount() {
        this.cargarDatos();
    }

    cargarDatos = () => {
        fetch(api + "solvencias", {
            headers: authHeaders()
        })
        .then(respuesta => respuesta.json())
        .then(datosRespuesta => {

           

            this.setState({
                datosCargados: true,
                solvencias: Array.isArray(datosRespuesta) ? datosRespuesta : []
            });

        })
        .catch(error => {

            

            this.setState({
                datosCargados: true,
                solvencias: []
            });

        });
    };

    cambioValor = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    };

 

    imprimirSolvencia = async (id) => {
    try {
        const respuesta = await fetch(api + `reportes/solvencias/${id}/imprimir`, {
            method: "GET",
            headers: authHeaders()
        });

        if (!respuesta.ok) {
            const error = await respuesta.text();
           
            alert("No se pudo imprimir la solvencia.");
            return;
        }

        const blob = await respuesta.blob();
        const fileURL = window.URL.createObjectURL(blob);

        window.open(fileURL, "_blank");

    } catch (error) {
     
        alert("Error al imprimir la solvencia.");
    }
}

    render() {
        const { datosCargados, solvencias, busqueda } = this.state;

        const solvenciasFiltradas = solvencias.filter((item) =>
            item.placa?.toLowerCase().includes(busqueda.toLowerCase()) ||
            item.nombre?.toLowerCase().includes(busqueda.toLowerCase()) ||
            item.tipoplaca?.toLowerCase().includes(busqueda.toLowerCase())
        );

        if (!datosCargados) {
            return <div>Cargando...</div>;
        }

        return (
            <div className="card">
                <div className="card-header">
                    <h4 className="mb-0">Solvencias emitidas</h4>
                </div>

                <div className="card-body">
                    <div className="row mb-3">
                        <div className="col-md-4">
                            <input
                                type="text"
                                name="busqueda"
                                className="form-control"
                                placeholder="Buscar por placa, propietario o tipo"
                                value={busqueda}
                                onChange={this.cambioValor}
                            />
                        </div>
                    </div>

                    <table className="table table-bordered table-hover">
                        <thead className="table-dark">
                            <tr>
                                <th>No.</th>
                                <th>Fecha</th>
                                <th>Placa</th>
                                <th>Tipo</th>
                                <th>Propietario</th>
                                <th>Usuario</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>

                        <tbody>
                            {solvenciasFiltradas.map((solvencia) => (
                                <tr key={solvencia.idsolvencia}>
                                    <td>
                                        SV-{new Date(solvencia.fecha).getFullYear()}-
                                        {String(solvencia.idsolvencia).padStart(5, "0")}
                                    </td>

                                    <td>{solvencia.fecha}</td>
                                    <td>{solvencia.placa}</td>
                                    <td>{solvencia.tipoplaca}</td>
                                    <td>{solvencia.nombre}</td>
                                    <td>{solvencia.usuario}</td>

                                 <td>
    <button
        className="btn btn-secondary btn-sm"
        onClick={() => this.imprimirSolvencia(solvencia.idsolvencia)}
        title="Imprimir solvencia"
    >
        <i className="bi bi-printer"></i>
    </button>
</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    {solvenciasFiltradas.length === 0 && (
                        <div className="alert alert-warning">
                            No se encontraron solvencias.
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default Listarsolvencias;